import {
    useMutation,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import {
    OrderStep,
} from 'app/Apps/OrderManagement/Orders/orders.types'
import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import requests from 'app/requests/Order/Order.requests'
import {
    OrderModificationType,
} from 'app/enums/label.enums'
import simpleApi from 'app/services/simpleApi'

type RequestParams = {
    modificationType: OrderModificationType,
    orderNumber: string,
    data: OrderStep & {version: number},
    id: number,
}

const useUpdateOrderStep = (onSuccess: () => void) => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessUpdate,
        onError,
    } = useHandleStatusRequest({
        id: 'ModifyOrderStep',
        onSuccess,
    })

    return useMutation({
        mutationFn: ({
            modificationType,
            orderNumber,
            data,
            id,
        }: RequestParams) => {
            return simpleApi({
                ...requests.updateOrderStep({
                    orderNumber,
                    modificationType,
                    data,
                    orderStepId: id,
                }),
                token,
            })
        },
        onSuccess: onSuccessUpdate,
        onError,
    })
}

export default useUpdateOrderStep
